import React from 'react';
import { useAuth } from '../../hooks/useAuth';

function normalizeRoleName(r) {
  if (!r) return '';
  if (typeof r === 'string') return r.trim().toLowerCase();
  if (typeof r === 'object' && r.name != null) return String(r.name).trim().toLowerCase();
  return String(r).trim().toLowerCase();
}

export function hasAnyRole(userRoles, required = []) {
  if (!required?.length) return false; //Si no especifica el atributo roles, retornamos false.
  const set = new Set((userRoles ?? []).map((r) => normalizeRoleName(r?.name ?? r)));
  return required.some((r) => set.has(normalizeRoleName(r)));
}

/**
 * Mientras loading === true no decide (evita falsos negativos).
 * Props:
 *  - roles: string | array
 *  - fallback: ReactNode
 *  - showWhileLoading: ReactNode (opcional)
 */
export function RequireRole({ roles, fallback = null, showWhileLoading = null, children }) {
  const { user, loading } = useAuth();

  // Esperar a que termine la hidratación del usuario
  if (loading) {
    return showWhileLoading !== null ? <>{showWhileLoading}</> : null;
  }

  const required = Array.isArray(roles) ? roles : roles ? [roles] : [];
  const ok = hasAnyRole(user?.data?.roles, required);

  return <>{ok ? children : fallback}</>;
}